import { useEffect } from 'react';
import { AdvancedMarker, Map, MapMouseEvent } from '@vis.gl/react-google-maps';
import css from './GoogleMap.module.css';
import { GOOGLE_MAP_ID } from '../../Constants/GoogleMap/GoogleMapId';
import { useGoogleMapViewModel } from '@viewModels/GoogleMap/GoogleMapViewModel';
import classNames from 'classnames';

interface GoogleMapProps {
    isDisabled?: boolean;
}

export const GoogleMap: React.FC<GoogleMapProps> = ({ isDisabled = false }) => {
    const {
        setMarkerPosition,
        setAddress,
        getAddressFromLatLng,
        isWithinCountry,
        markerPosition,
        setAddressSuggestions,
    } = useGoogleMapViewModel();

    useEffect(() => {
        const handleClickOutside = () => {
            setAddressSuggestions([]);
        };
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    const handleMapClick = async (event: MapMouseEvent) => {
        const lat = event.detail.latLng?.lat ?? 0;
        const lng = event.detail.latLng?.lng ?? 0;

        const isValidLocation = await isWithinCountry(lat, lng);

        if (isValidLocation) {
            setMarkerPosition({ lat, lng });
            await getAddressFromLatLng(lat, lng);
        } else {
            setMarkerPosition(null);
            setAddress('');
        }
    };

    return (
        <Map
            defaultCenter={{ lat: -30.5595, lng: 22.9375 }}
            defaultZoom={6}
            gestureHandling={'greedy'}
            disableDefaultUI={true}
            onClick={handleMapClick}
            mapId={GOOGLE_MAP_ID}
            id={GOOGLE_MAP_ID}
            className={classNames(css.googleMap, {
                [css.disabled]: isDisabled,
            })}
        >
            {markerPosition && (
                <AdvancedMarker
                    position={markerPosition}
                    draggable={!isDisabled}
                    clickable={!isDisabled}
                />
            )}
        </Map>
    );
};
